import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import * as userActions from "./actions/userActions";
import "./App.css";
import PrivateRoute from "./PrivateRoute";
import {
  USER_LOCAL_ID,
  USER_ID,
  LOGIN_PAGE_PATH,
  API_TOKEN_NAME,
} from "./constants";
import { thirdparty, scAxiosAdmin } from "./.";
import Dashboard from "./component/dashboard";
import Packages from "./component/frontend/Packages";
import DoctorProfile from "./component/frontend/DoctorProfile";
//import Homecardic from './component/frontend/homecrdic/Homcardic';
import Homecardicepage from "./component/frontend/Homecardicepage";
import register from "./component/register";
import Login from "./component/Login";
import forgetpassword from "./component/forgetpassword";
import ResetPassword from "./component/ResetPassword";
import Logout from "./component/Logout";
import appointments from "./component/dashboard/appointments";
import doctorportal from "./component/dashboard/doctorportal";
import emergency from "./component/frontend/emergency";
import patientoverview from "./component/dashboard/patientoverview";
import patientoverviewtwo from "./component/dashboard/patientoverviewtwo";
import patientportal from "./component/dashboard/patientportal";
import patientportaltwo from "./component/dashboard/patientportaltwo";
import patientreports from "./component/dashboard/patientreports";
import patientlists from "./component/frontend/PatientLists";
//import admindashboard from './component/admin/admindashboard';
import adminlogin from "./component/adminlogin";
import AdminLogout from "./component/adminlogout";
import adminregister from "./component/adminregister";
import cancel from "./component/payment/cancel";
import fail from "./component/payment/fail";
import success from "./component/payment/success";
import PopupPatientId from "./component/frontend/PopupPatientId";
import PhotoGallery from "./component/frontend/PhotoGallery";
import PhotoGalleryInner from "./component/frontend/PhotoGalleryInner";
import BriefHistory from "./component/frontend/BriefHistory";
import Corporateclient from "./component/frontend/Corporateclient";
import MissionStatement from "./component/frontend/MissionStatement";
import BoardMembers from "./component/frontend/BoardMembers";
import privacypolicy from "./component/frontend/privacypolicy";
import termscondition from "./component/frontend/termscondition";
import declaration from "./component/frontend/declaration";
import singlenewsevents from "./component/frontend/singlenewsevents";
import singlepublication from "./component/frontend/singlepublication";
import singlepackage from "./component/frontend/singlepackage";
import testimonials from "./component/frontend/testimonials";
import DepartmentView from "./component/frontend/DepartmentView";
import DepartmentsView from "./component/frontend/DepartmentsView";
import StaticPages from "./component/frontend/staticpages";
import OperationTeam from "./component/frontend/OperationTeam";
import LatestNews from "./component/frontend/LatestNews";
import NoticeBoard from "./component/frontend/NoticeBoard";
import Publications from "./component/frontend/Publications";
import PeopleDiversity from "./component/frontend/PeopleDiversity";
import Location from "./component/frontend/Location";
import VideoGallery from "./component/frontend/VideoGallery";
import EditAlbum from "./component/admin/editAlbum";
import ForgotPass from "./component/frontend/ForgotPass";
import resetnewpassword from "./component/frontend/resetnewpassword";
import Services from "./component/frontend/Services";
import DeathCertificate from "./component/frontend/DeathCertificate";
import BirthCertificate from "./component/frontend/BirthCertificate";
import HomeSampleCollection from "./component/frontend/HomeSampleCollection";
import Atm from "./component/frontend/Atm";
import Cafeteria from "./component/frontend/Cafeteria";
import Investigation from "./component/frontend/Investigation";
import Telemedicine from "./component/frontend/Telemedicine";
import Mortuary from "./component/frontend/Mortuary";
import Pharmacy from "./component/frontend/Pharmacy";
import RoomCategory from "./component/frontend/RoomCategory";

import WriteToUs from "./component/frontend/WriteToUs";
import CvUpload from "./component/frontend/CvUpload";
import DayCare from "./component/frontend/DayCare";
import DischargeProtocols from "./component/frontend/DischargeProtocols";
import EveningOPD from "./component/frontend/EveningOPD";
import Vaccination from "./component/frontend/Vaccination";
import PatientProtal from "./component/frontend/PatientProtal";
import Cart from "./component/frontend/Cart";
import MyProvider from "./component/MyProvider";
import successOrder from "./component/payment/successOrder";
import PatientBillHistory from "./component/frontend/PatientBillHistory";
import LifeAtUHL from "./component/frontend/LifeAtUHL";
import CaseStudy from "./component/frontend/commonsections/CaseStudy";
import CaseStudyPage from "./component/frontend/CaseStudyPage";
import CaseStudyDetails from "./component/frontend/CaseStudyDetails";
import Career from "./component/frontend/Career";
import CareerInside from "./component/frontend/CareerInside";
import BlogDetails from "./component/frontend/Blog";
import PhotoGalleryNew from "./component/frontend/PhotoGalleryNew/PhotoGalleryNew";
import SingleTestimonials from "./component/frontend/singleTestimonials";
import BookAppointmentPopup from "./component/frontend/BookAppointmentPopup";
import About from "./component/frontend/About";
import ContactUs from "./component/frontend/ContactUs";
import UserChangepassword from "./component/admin/UserChangePassword";
import Layout from "./component/Layout";
import SideDrawerMenus from "./component/frontend/SideDrawerMenus";
import Home from "./component/frontend/Home";
// import GLOBAL_CONTEXT from "./component/globalContext";

const getStaticPages = () => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/staticpages/getstaticpages", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

const user_log = () => {
  return new Promise((resolve, reject) => {
    let login_data = {
      type: "Browse",
      user_id: localStorage.getItem(USER_LOCAL_ID) || null,
      url: window.location.pathname,
    };
    const user_log = thirdparty.post("/user_log", login_data);
  });
};
class App extends Component {
  // static contextType = GLOBAL_CONTEXT;
  state = {
    staticpages: [],
  };
  /*refreshGetStaticPages = () => {
    getStaticPages()
      .then(res => {
        if (res.status === true) {
          var records = res.data;
          this.setState({ staticpages: records });
        } else {
          this.setState({ staticpages: '' });
        }
      })
      .catch(err => {
        console.log("",err);
      });
  }*/
  componentDidMount() {
    user_log();
    //this.refreshGetStaticPages();
  }
  render() {
    // const { user, userdata } = this.context;
    return (
      <MyProvider>
        <Router>
          <Switch>
            {/* <Layout> */}
            <Route exact path="/" component={Home} />
            <Route path="/logout" component={Logout} />
            <Route path="/adminlogout" component={AdminLogout} />
            <Route path="/resetpassword" component={ResetPassword} />
            <Route path="/forgetpassword" component={forgetpassword} />
            {/*<Route path='/pages/packages' component={Packages} />*/}
            <Route path="/pages/packages" component={Packages} />
            <Route path="/pages/homecardic" component={Homecardicepage} />
            <Route path="/pages/emergency" component={emergency} />
            <Route path="/page/brief-history" component={BriefHistory} />
            <Route path="/page/about" component={About} />
            <Route
              path="/page/mission-statement"
              component={MissionStatement}
            />
            <Route
              path="/pages/death-certificate"
              component={DeathCertificate}
            />
            <Route
              path="/pages/birth-certificate"
              component={BirthCertificate}
            />
            <Route
              path="/pages/home-sample-collection"
              component={HomeSampleCollection}
            />
            <Route path="/pages/atm" component={Atm} />
            <Route path="/pages/life-at-uhl" component={LifeAtUHL} />
            <Route path="/pages/case-study/:id" component={CaseStudyDetails} />
            <Route path="/pages/case-study" component={CaseStudyPage} />
            <Route path="/pages/career/cv-upload/:id" component={CvUpload} />
            <Route path="/pages/career/:id" component={CareerInside} />
            <Route path="/pages/career" component={Career} />
            <Route path="/pages/blog/:id" component={BlogDetails} />
            <Route path="/pages/cafeteria" component={Cafeteria} />
            <Route path="/pages/investigation" component={Investigation} />
            <Route path="/pages/evening-opd" component={EveningOPD} />
            <Route path="/pages/telemedicine" component={Telemedicine} />
            <Route path="/pages/mortuary" component={Mortuary} />
            <Route path="/pages/pharmacy" component={Pharmacy} />
            <Route path="/pages/room-category" component={RoomCategory} />
            <Route path="/pages/vaccination" component={Vaccination} />
            <Route path="/pages/day-care" component={DayCare} />
            <Route
              path="/services/corporate-client"
              component={Corporateclient}
            />
            <Route
              path="/pages/discharge-protocols"
              component={DischargeProtocols}
            />
            <Route path="/pages/write-to-us" component={WriteToUs} />
            <Route path="/pages/departments" component={DepartmentsView} />
            <Route path="/pages/services" component={Services} />
            <Route
              path="/pages/patientbillhistory"
              component={PatientBillHistory}
            />
            <Route path="/pages/:slug" component={StaticPages} />
            <Route path="/patient-protal" component={PatientProtal} />
            <Route path="/news/index" component={LatestNews} />
            {/* <Route path="/news/index" component={NoticeBoard} /> */}
            <Route path="/news/page/:page" component={LatestNews} />
            <Route path="/news/:name" component={singlenewsevents} />
            <Route path="/testimonials/:name" component={SingleTestimonials} />
            <Route path="/news" component={LatestNews} />
            {/* <Route path="/noticeboard" component={NoticeBoard} /> */}
            <Route path="/patientlists" component={patientlists} />
            <Route path="/gallery/video-gallery/" component={VideoGallery} />
            <Route path="pages/emergency" component={emergency} />
            <Route path="/cancel" component={cancel} />
            <Route path="/cart" component={Cart} />
            <Route path="/fail" component={fail} />
            <Route path="/success" component={success} />
            <Route path="/success-order" component={successOrder} />
            <Route path="/popuppatientid" component={PopupPatientId} />
            <Route path="/page/board-members" component={BoardMembers} />
            <Route
              path="/gallery/photo-gallery/:slug"
              component={PhotoGalleryInner}
            />
            <Route path="/page/operation-team" component={OperationTeam} />
            <Route path="/forgot-pass" component={ForgotPass} />
            <Route path="/reset-new-password" component={resetnewpassword} />
            <Route path="/page/people-diversity" component={PeopleDiversity} />
            <Route
              path="/admin/change-password"
              component={UserChangepassword}
            />
            <Route path="/publication" component={Publications} />
            <Route path="/page/contact" component={ContactUs} />
            <Route path="/privacy-policy" component={privacypolicy} />
            <Route path="/location" component={Location} />
            <Route path="/gallery/photo-gallery" component={PhotoGalleryNew} />
            {/* <Route path="/gallery/photo-gallery" component={PhotoGallery} /> */}
            <Route path="/terms-conditions" component={termscondition} />
            <Route path="/declaration" component={declaration} />
            <Route path="/publications/:name" component={singlepublication} />
            <Route path="/packages/:name" component={singlepackage} />
            <Route path="/alltestimonials" component={testimonials} />
            <Route path={LOGIN_PAGE_PATH} component={Login} />
            <Route path="/signup" component={register} />
            {/*<Route path='/doctor/:name' component={DoctorProfile} />*/}
            <Route path="/departments/:name" component={DepartmentView} />
            <Route path="/department/:name" component={DepartmentView} />
            <Route path="/consultant/:name" component={DoctorProfile} />
            <Route path="/home" component={Home} />
            <Route
              path="/dashboard/patient-dashboard"
              component={patientoverview}
            />
            <Route path="/dashboard/appoinments" component={appointments} />
            <Route path="/dashboard/doctor-portal" component={doctorportal} />
            <Route
              path="/dashboard/patient-overview-two"
              component={patientoverviewtwo}
            />
            <Route path="/dashboard/patient-portal" component={patientportal} />
            <Route
              path="/dashboard/patient-portal-two"
              component={patientportaltwo}
            />
            <Route
              path="/dashboard/patient-reports"
              component={patientreports}
            />
            {/*<Route path="/admindashboard" component={admindashboard} />*/}
            <Route path="/adminlogin" component={adminlogin} />
            <Route path="/adminregister" component={adminregister} />{" "}
            {/* </Layout> */}
            <PrivateRoute
              path="/"
              component={Dashboard}
              user={this.props.user}
            />
          </Switch>
          <SideDrawerMenus></SideDrawerMenus>
        </Router>
        <BookAppointmentPopup></BookAppointmentPopup>
        {/*  */}
      </MyProvider>
    );
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(userActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js